import { Component, effect, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { crewDashboardEvents } from '@navstation-portal/reporting/data-access/crew-dashboard';
import {
  vesselParticularsEvents,
  vesselSpecEvents,
  VesselsStore,
} from '@navstation-portal/vessels/data-access/store';
import { Vessel } from '@navstation-portal/vessels/data-model/vessel';
import { injectDispatch } from '@ngrx/signals/events';
import { ListboxModule } from 'primeng/listbox';
import {
  AppStore,
  appEvents,
} from '@navstation-portal/reporting/data-access/app';

@Component({
  selector: 're-vessel-selector-content',
  templateUrl: './vessel-selector-content.component.html',
  styleUrl: './vessel-selector-content.component.css',
  imports: [FormsModule, ListboxModule],
})
export class VesselSelectorContentComponent {
  readonly appStore = inject(AppStore);
  readonly vesselsStore = inject(VesselsStore);
  readonly appDispatch = injectDispatch(appEvents);
  readonly vesselSpecDispatch = injectDispatch(vesselSpecEvents);
  readonly vesselParticularsDispatch = injectDispatch(vesselParticularsEvents);
  readonly crewDashboardDispatch = injectDispatch(crewDashboardEvents);

  constructor() {
    if (this.appStore.selectedVessel()) return;
    effect(() => {
      const selectedVesselId = this.appStore.selectedVesselId();
      const defaultVesselId = this.appStore.defaultVesselId();
      const vesselId = selectedVesselId || defaultVesselId;
      if (!vesselId) return;

      const vessels = this.vesselsStore.vessels();
      if (!vessels.length) return;

      const vessel = vessels.find((v) => v.id == vesselId);
      if (!vessel) return;

      this.appDispatch.setSelectedVessel(vessel);
    });
  }

  vesselClicked = (vessel: Vessel) => {
    if (!vessel) return;

    this.appDispatch.setSelectedVesselId(vessel.id);
    this.appDispatch.setSelectedVessel(vessel);
    this.vesselSpecDispatch.fetchVesselSpec(vessel.id);
    this.vesselParticularsDispatch.fetchVesselParticulars(vessel.id);
    this.crewDashboardDispatch.fetchDashboardData(vessel.id);
  };
}
